import { ApiRoutes } from "@futgg/core";
import axios from 'axios';
import Navigo from 'navigo';
var JS_LIBRARY_ARTICLE_LINK_SELECTOR = '.js-library-article-link';
var JS_LIBRARY_SUBCATEGORY_LI_SELECTOR = '.js-library-subcategory-li';
var JS_LIBRARY_ACCORDION_TRIGGER_SELECTOR = '.js-library-accordion-trigger';
var JS_LIBRARY_ACCORDION_UL_SELECTOR = '.js-library-accordion-ul';
var JS_LIBRARY_LOADING_SELECTOR = '.js-library-article-loading';
var JS_LIBRARY_ERROR_SELECTOR = '.js-library-article-error';
var JS_LIBRARY_ARTICLE_CONTAINER_SELECTOR = '.js-library-article-container';
var JS_LIBRARY_MOBILE_BUTTON = '.js-library-mobile-button';
var JS_LIBRARY_TITLE = '.js-library-title';
var LIBRARY_LOADING_HIDDEN_CLASS = 'library__loading--hidden';
var LIBRARY_ERROR_HIDDEN_CLASS = 'library__error--hidden';
var LIBRARY_ARTICLE_CONTAINER_HIDDEN_CLASS = 'library__content--hidden';
var LIBRARY_SIDEBAR_LINK_ACTIVE_CLASS = 'library__sidebar-link--active';
var LIBRARY_SIDEBAR_SUBCATEGORY_ACTIVE_CLASS = 'library__sidebar-link--active';
var LIBRARY_SIDEBAR_LINK_LOADING_CLASS = 'library__sidebar-link--loading';
var LIBRARY_SIDEBAR_CLASS = 'library__sidebar';
var LIBRARY_SIDEBAR_ACTIVE_CLASS = 'library__sidebar--active';
var isNavOpen = false;
function initNavigo() {
    var router = new Navigo('/');
    var controller = null;
    router.on('library/:slug/', function (params) {
        var _a, _b;
        var articleSlug = (_b = (_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : null;
        if (articleSlug === null) {
            return;
        }
        window.scrollTo(0, 0);
        showLoading();
        hideError();
        hideArticle();
        clearActiveLinks();
        closeSidebar();
        clearLoadingLinks();
        addActiveLoadingLinks(articleSlug);
        if (!controller) {
            controller = new AbortController();
        }
        else {
            controller.abort();
            controller = new AbortController();
        }
        axios.get(ApiRoutes.getApiLibraryArticleDetail(articleSlug), {
            signal: controller.signal
        }).then(function (response) {
            var articleContainer = document.querySelector(JS_LIBRARY_ARTICLE_CONTAINER_SELECTOR);
            if (articleContainer) {
                articleContainer.innerHTML = response.data;
            }
            hideLoading();
            showArticle();
            clearLoadingLinks();
            addActiveLinkClass(articleSlug);
            changeActiveArticleLabel(articleSlug);
            router.updatePageLinks();
        })
            .catch(function (error) {
            if (error.name === 'CanceledError') {
                return;
            }
            else {
                hideLoading();
                showError();
            }
        });
    });
}
function clearLoadingLinks() {
    var loadingLinks = document.querySelectorAll(JS_LIBRARY_ARTICLE_LINK_SELECTOR);
    if (loadingLinks) {
        for (var i = 0; i < loadingLinks.length; i++) {
            loadingLinks[i].classList.remove(LIBRARY_SIDEBAR_LINK_LOADING_CLASS);
        }
    }
}
function addActiveLoadingLinks(articleSlug) {
    var _a;
    var links = document.querySelectorAll(JS_LIBRARY_ARTICLE_LINK_SELECTOR);
    if (links) {
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            if (link) {
                var linkSlug = (_a = link.dataset.articleSlug) !== null && _a !== void 0 ? _a : null;
                if (linkSlug === articleSlug) {
                    link.classList.add(LIBRARY_SIDEBAR_LINK_LOADING_CLASS);
                }
            }
        }
    }
}
function clearActiveLinks() {
    var links = document.querySelectorAll('.' + LIBRARY_SIDEBAR_LINK_ACTIVE_CLASS);
    if (links) {
        for (var i = 0; i < links.length; i++) {
            links[i].classList.remove(LIBRARY_SIDEBAR_LINK_ACTIVE_CLASS);
        }
    }
}
function changeActiveArticleLabel(articleSlug) {
    var _a;
    var titleElement = document.querySelector(JS_LIBRARY_TITLE);
    if (titleElement) {
        var link = document.querySelector("[data-article-slug=\"".concat(articleSlug, "\"]"));
        if (link) {
            titleElement.innerHTML = (_a = link.dataset.label) !== null && _a !== void 0 ? _a : '';
            if (link.dataset.title) {
                document.title = link.dataset.title;
            }
        }
    }
}
function addActiveLinkClass(articleSlug) {
    var _a;
    var links = document.querySelectorAll(JS_LIBRARY_ARTICLE_LINK_SELECTOR);
    if (links) {
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            if (link) {
                var linkSlug = (_a = link.dataset.articleSlug) !== null && _a !== void 0 ? _a : null;
                if (linkSlug === articleSlug) {
                    link.classList.add(LIBRARY_SIDEBAR_LINK_ACTIVE_CLASS);
                }
            }
        }
    }
}
function hideLoading() {
    var loadingElement = document.querySelector(JS_LIBRARY_LOADING_SELECTOR);
    if (loadingElement) {
        loadingElement.classList.add(LIBRARY_LOADING_HIDDEN_CLASS);
    }
}
function showLoading() {
    var loadingElement = document.querySelector(JS_LIBRARY_LOADING_SELECTOR);
    if (loadingElement) {
        loadingElement.classList.remove(LIBRARY_LOADING_HIDDEN_CLASS);
    }
}
function showError() {
    var errorElement = document.querySelector(JS_LIBRARY_ERROR_SELECTOR);
    if (errorElement) {
        errorElement.classList.remove(LIBRARY_ERROR_HIDDEN_CLASS);
    }
}
function hideError() {
    var errorElement = document.querySelector(JS_LIBRARY_ERROR_SELECTOR);
    if (errorElement) {
        errorElement.classList.add(LIBRARY_ERROR_HIDDEN_CLASS);
    }
}
function hideArticle() {
    var articleContainerElement = document.querySelector(JS_LIBRARY_ARTICLE_CONTAINER_SELECTOR);
    if (articleContainerElement) {
        articleContainerElement.classList.add(LIBRARY_ARTICLE_CONTAINER_HIDDEN_CLASS);
    }
}
function showArticle() {
    var articleContainerElement = document.querySelector(JS_LIBRARY_ARTICLE_CONTAINER_SELECTOR);
    if (articleContainerElement) {
        articleContainerElement.classList.remove(LIBRARY_ARTICLE_CONTAINER_HIDDEN_CLASS);
    }
}
function closeSidebar() {
    var sidebarElement = document.querySelector('.' + LIBRARY_SIDEBAR_ACTIVE_CLASS);
    if (sidebarElement) {
        sidebarElement.classList.remove(LIBRARY_SIDEBAR_ACTIVE_CLASS);
        isNavOpen = false;
        document.body.style.overflow = 'auto';
    }
}
function openSidebar() {
    var sidebarElement = document.querySelector('.' + LIBRARY_SIDEBAR_CLASS);
    if (sidebarElement) {
        if (window.scrollY < 61) {
            window.scrollTo({
                left: 0,
                top: 76,
                behavior: 'smooth'
            });
        }
        sidebarElement.classList.add(LIBRARY_SIDEBAR_ACTIVE_CLASS);
        document.body.style.overflow = 'hidden';
        isNavOpen = true;
    }
}
function toggleSidebar() {
    if (isNavOpen) {
        closeSidebar();
        isNavOpen = false;
    }
    else {
        openSidebar();
        isNavOpen = true;
    }
}
function bindMobileNav() {
    var mobileNavElement = document.querySelector(JS_LIBRARY_MOBILE_BUTTON);
    if (mobileNavElement) {
        mobileNavElement.addEventListener('click', function () {
            toggleSidebar();
        });
    }
}
function bindNavAccordion() {
    var _a;
    var subcategoryLinks = document.querySelectorAll(JS_LIBRARY_ACCORDION_TRIGGER_SELECTOR);
    if (subcategoryLinks) {
        var _loop_1 = function (i) {
            var subcategoryLink = subcategoryLinks[i];
            if (subcategoryLink) {
                var subcategoryId_1 = (_a = subcategoryLink.dataset.subcategoryId) !== null && _a !== void 0 ? _a : null;
                if (subcategoryId_1) {
                    subcategoryLink.addEventListener('click', function () {
                        if (subcategoryLink.classList.contains(LIBRARY_SIDEBAR_SUBCATEGORY_ACTIVE_CLASS)) {
                            return;
                        }
                        var subcategoryElement = document.querySelector("".concat(JS_LIBRARY_SUBCATEGORY_LI_SELECTOR, "[data-subcategory-id=\"").concat(subcategoryId_1, "\"]"));
                        if (subcategoryElement) {
                            closeAllAccordions();
                            subcategoryElement.classList.add('show');
                        }
                    });
                }
            }
        };
        for (var i = 0; i < subcategoryLinks.length; i++) {
            _loop_1(i);
        }
    }
}
function closeAllAccordions() {
    var activeSubcategories = document.querySelectorAll("".concat(JS_LIBRARY_SUBCATEGORY_LI_SELECTOR, ".show"));
    if (activeSubcategories) {
        for (var j = 0; j < activeSubcategories.length; j++) {
            var activeSubcategory = activeSubcategories[j];
            if (activeSubcategory) {
                activeSubcategory.classList.remove('show');
            }
        }
    }
}
export function futLibraryInit() {
    initNavigo();
    bindMobileNav();
    bindNavAccordion();
}
